import React from "react";
import { Snackbar, Alert, Slide } from "@mui/material";
import { snackbarStore } from "src/store/snackbarStore";

// severity = "success" | "info" | "warning" | "error"
const CustomSnackbar: React.FC = () => {
  const { snackbars, removeSnackbar } = snackbarStore();

  return (
    <>
      {snackbars.map((snackbar, index) => (
        <Snackbar
          key={snackbar.id}
          open
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          autoHideDuration={3000}
          onClose={() => removeSnackbar(snackbar.id)}
          sx={{ top: `${16 + index * 70}px` }}
        >
          <Alert
            onClose={() => removeSnackbar(snackbar.id)}
            severity={snackbar.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default CustomSnackbar;
